import React from "react";
import { Col, Container, Row } from "reactstrap";
import DashboardGraph from "./components/DashboardGraph";
import DashboardUsers from "../../LimeProxyComponents/Users/DashboardUsers";

const ECommerceDashboard = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Dashboard</h3>
      </Col>
    </Row>
    <Row>
      <DashboardGraph
        title="Total Users"
        type="total_users"
        barColor="#ff4861"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Total Credits"
        type="total_credits"
        barColor="#70bbfd"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Recent Signups"
        type="recent_signups"
        barColor="#c88ffa"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Total Subscriptions"
        type="total_subscriptions"
        barColor="#f6da6e"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Pending Users"
        type="pending_users"
        barColor="#17a2b8"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Activated Trail"
        type="active_trial_users"
        barColor="#ffc107"
        activeColor="#4ce1b6"
      />
      <DashboardGraph
        title="Cancellation Requests"
        type="cancellation_users"
        barColor="#007bff"
        activeColor="#4ce1b6"
      />
    </Row>
    <Row>
      <DashboardUsers />
    </Row>
  </Container>
);

export default ECommerceDashboard;
